import style from './FormHead.module.scss';

type TProp = {
	title: string;
	text: string;
};
const FormHead = ({ title, text }: TProp) => {
	return (
		<header className={style['form-head']}>
			<h1>{title}</h1>
			<p>{text}</p>
		</header>
	);
};

export default FormHead;
